import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
  AdminItemsRow,
  AdminItemsContainer,
  AdminItemContainer,
} from "../../admin.styled"

import { useState } from "react";
import { deleteApiKey } from "modules/agentMySecurity/services/embeddingsService";
import { formatDate } from "core/lib/utils";
import { ConfirmationDialog } from "core/components/global/confirmationDialogBox/confirmationDialog";
import { Toast } from "core/components/global/toast/toast";


export default function AdminGroup({ apiKey, groups, onDelete }) {
    const [openRow, setRowOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDeleteClick = () => {
        setOpenDialog(true);
    };

    const handleDelete = async () => {
        try {
            setIsDeleting(true);
            const response = await deleteApiKey(apiKey._id);
            
            if (response !== null) {
                onDelete(apiKey._id);
                Toast("API Key deleted successfully", "success");
            } else {
                Toast("Failed to delete API Key", "error");
            }
        } catch (error) {
            console.error("Delete error:", error);
            Toast("Error deleting API Key", "error");
        } finally {
            setIsDeleting(false);
            setOpenDialog(false);
        }
    }

    return (
        <>
            <AdminItemsRow>
                <div className="unexpanded-row-container">
                    <div className="row-items" onClick={() => setRowOpen(!openRow)}>
                        <p className="row-item">{apiKey.description}</p>
                        <p className="row-item">{formatDate(apiKey.createdAt)}</p>
                        <p className="row-item">{apiKey.created_by}</p>
                    </div>
                    <div className="row-buttons">
                        <IconButton 
                            onClick={handleDeleteClick}
                            disabled={isDeleting}
                        >
                            <DeleteOutlineOutlinedIcon fontSize="small" color="error"/>
                        </IconButton>
                    </div>
                </div>

                {openRow && (
                    <AdminItemsContainer>
                        <AdminItemContainer>
                            <strong>Created At:</strong>
                            <p>{apiKey.createdAt}</p>
                        </AdminItemContainer>
                        <AdminItemContainer>
                            <strong>Created By:</strong>
                            <p>{apiKey.created_by}</p>
                        </AdminItemContainer>
                        <AdminItemContainer>
                            <strong>Groups:</strong>
                            <ul>
                                {  
                                    apiKey.groups.map((group) => {
                                        return <li key={group}>{group}</li>
                                    })
                                }
                            </ul>
                        </AdminItemContainer>
                    </AdminItemsContainer>
                )}
            </AdminItemsRow>

            <ConfirmationDialog
                open={openDialog}
                title="Confirm Delete"
                message={`Are you sure you want to delete this API Key?`}
                isLoading={isDeleting}
                onClose={() => setOpenDialog(false)}
                onConfirm={handleDelete}
            />
        </>
    );
}